import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext.jsx';
// A guide URL's explicit locale is deterministic while the shared preference hydrates.
// The wider preference lifecycle remains in its separately preserved candidate.
export default function useHelpLanguage() {
  const context = useLanguage();
  const requested = new URLSearchParams(useLocation().search).get('lang');
  return { ...context, languageCode: ['fr','en-GB'].includes(requested) ? requested : context.languageCode };
}
